import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import Quasar from 'quasar/src/vue-plugin.js';;
import quasarUserOptions from "./quasar-user-options";
import VueSmoothScroll from "vue3-smooth-scroll";

createApp(App)
  .use(Quasar, quasarUserOptions)
  .use(router)
  .use(VueSmoothScroll)
  .mount("#app");
